import Heading from '@components/Heading/Heading';
import styles from '@features/cms/components/inspirations/InspirationProductGallerySingle/InspirationProductGallerySingle.styles';
import { IInspirationProductGallerySingle } from '@features/cms/typescript';
import ProductImageSingle from '@features/cms/components/inspirations/InspirationProductGallerySingle/ProductImageSingle';
import theme from '@styles/theme';
type PropsType = {
  data: IInspirationProductGallerySingle;
  defaultBackground?: string;
};
const InspirationProductGallerySingle = ({
  data,
  defaultBackground = theme.rawColors.neutralWhite
}: PropsType) => {
  const {
    image,
    background,
    leftText,
    leftTextColor,
    rightText,
    rightTextColor,
    products,
    variant,
    imageWithBlur,
    code
  } = data;
  return <section id={code} sx={styles.singleGallerySection(background || defaultBackground, variant)} data-testid={code}>
      <ProductImageSingle products={products} isRightText={!!rightText} variant={variant} image={image} imageWithBlur={imageWithBlur} alt={leftText || rightText || products[0]?.name || ''} data-testid="inspiration-product-gallery-single-product-image" />
      {variant === 'singleDefault' && <>
          {leftText && <div sx={styles.textBox(false)} data-testid="inspiration-product-gallery-single-left-text">
              <Heading h={4} headingType={4} color={leftTextColor} mobile>
                {leftText}
              </Heading>
            </div>}
          {rightText && <div sx={styles.textBox(true)} data-testid="inspiration-product-gallery-single-right-text">
              <Heading h={4} headingType={4} color={rightTextColor} mobile>
                {rightText}
              </Heading>
            </div>}
        </>}
    </section>;
};
export default InspirationProductGallerySingle;